import { useEffect, useState } from "react";
import { DeepPartial, FieldValues, FormProvider, useForm } from "react-hook-form";
import { Modal, ModalProps } from "antd";

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const validateEmail = (email: string, fieldName: string) => {
  if (!email.match(emailRegex)) {
    /* eslint-disable-next-line no-throw-literal */
    throw { field: fieldName, formError: { type: 'invalid_email', message: 'Invalid email address' } }
  }
}

export interface FormModalProps<T extends FieldValues> extends Omit<ModalProps, 'onOk' | 'visible'> {
  // defaultValues?: DeepPartial<T>,
  defaultValues?: any,
  onOk: (values: T) => void,
  skipDirtyValidation?: boolean,
}

export default function FormModal<T extends FieldValues>({ open, defaultValues, onOk, children, skipDirtyValidation, ...restProps }: FormModalProps<T>) {
  const methods = useForm<T>({
    mode: "onChange",
    defaultValues
  });
  const { reset, setError, getValues, formState: { isValid, isDirty } } = methods
  const [loading, setLoading] = useState<boolean>(false);
  const disabled = !isValid || (!skipDirtyValidation && !isDirty)

  useEffect(() => {
    if (open) {
      reset(defaultValues || {} as DeepPartial<T>)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const handleOk = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    try {
      setLoading(true)
      // @ts-ignore
      await onOk(getValues())
      setLoading(false)
      restProps.onCancel?.(e)
    } catch (error: any) {
      if (error.field) {
        setError(error.field, error.formError)
      } else {
        console.error(error)
      }
      setLoading(false)
    }
  }

  return (
    <Modal open={open} {...restProps} onOk={handleOk} okButtonProps={{ loading, disabled }} destroyOnClose>
      <FormProvider {...methods}>
        <form>
          {children}
        </form>
      </FormProvider>
    </Modal>
  )
}
